// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font_size {
  font-size: 12px !important;
}

.ng-autocompleteroutr {
  width: 370px;
}

.search_btnss {
  background-color: #17a2b8;
  color: white;
  border: none;
  outline: none;
}

.reset_btnss {
  background-color: #17a2b8;
  color: white;
  border: none;
}

::ng-deep .mat-form-field-appearance-legacy .mat-form-field-wrapper {
  margin-top: -3% !important;
  margin-left: 2% !important;
}

.link_Nonhighlight {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
}

.link_highlight {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
  margin-right: 1%;
}

.link_highlight:hover {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
  background-color: #3fa4fb;
  padding-inline: 3%;
  padding-block: 2px;
  border-radius: 12px;
  color: white !important;
  cursor: pointer;
}

.iconCheck {
  font-size: 12px;
  position: relative;
  top: -20%;
  margin-left: -3px;
}

.doller {
  position: absolute;
  top: -11px;
  left: 15%;
}

.textCenter {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.text-success {
  color: #5dd077 !important;
}

.text-danger {
  color: #da606c !important;
}

.gui_ellipsis {
  font-weight: 600;
  max-width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}

.pipeline_ellipsis {
  max-width: 89%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  position: relative;
  top: 8%;
  left: 1%;
  padding-right: 1%;
}

.trans_ellipsis {
  max-width: 74%;
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  top: 11%;
  padding-right: 1%;
}

.active_card {
  border-left: 4px solid #07a36e;
}

.progress_card {
  border-left: 4px solid #ffc107;
}

.iconPointer:hover {
  pointer-events: all;
}

.arrow_source {
  left: 5%;
  width: 97%;
  height: 2px;
  background-color: grey;
  position: relative;
  top: 36%;
}

.arr_chev {
  position: relative;
  text-align: right !important;
  right: -98%;
  color: grey;
  top: -7px;
}

.failed_card {
  border-left: 4px solid #da606c;
}

.healing_card {
  border-left: 4px solid #f5a700;
}

.border-gradient {
  border-left: 4px solid !important;
  border-image-slice: 1;
  border-block: 0;
  border-right: 0;
}

.border-gradient-redgreen {
  border-image-source: linear-gradient(to bottom, #db6c6c, #22ed86);
}

.copy_icon {
  margin-left: 2%;
  cursor: pointer;
  font-size: 15px;
  position: absolute;
  top: 2px;
}

.pipeline_label {
  float: left;
  padding-right: 11%;
  position: relative;
  top: 8px;
}

.pipeline_feild {
  float: left;
  width: 100%;
}

.source_label {
  float: left;
  padding-right: 9%;
  position: relative;
  top: 8px;
}

.source_feild {
  float: left;
  width: 100%;
}

.target_label {
  float: left;
  padding-right: 13%;
  position: relative;
  top: 8px;
}

.target_feild {
  float: left;
  width: 100%;
}

.processor_label {
  float: left;
  padding-right: 7%;
  position: relative;
  top: 8px;
}

.processor_feild {
  float: left;
  width: 100%;
}

.message_label {
  float: left;
  padding-right: 9%;
  position: relative;
  top: 8px;
}

.message_feild {
  float: left;
  width: 100%;
}

.transaction_label {
  float: left;
  padding-right: 3%;
  position: relative;
  top: 8px;
}

.transaction_feild {
  float: left;
  width: 100%;
}

.textFeid {
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  width: 100%;
  height: 16.5vh;
  font-size: 12px !important;
}

.message_feild1 {
  float: left;
  font-size: 12px !important;
  height: 9.5vh;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  width: 100%;
}

.message_feild3 {
  float: left;
  font-size: 12px !important;
  height: 15.8vh;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  width: 100%;
}

.message_feild2 {
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  width: 100%;
  float: left;
  height: 5vh;
  font-size: 12px !important;
}

.message_type_label {
  float: left;
  padding-right: 3%;
  position: relative;
  top: 8px;
}

.message_type_feild {
  width: 100%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  top: -6px;
}

.message_type_label {
  float: left;
  padding-right: 2%;
  position: relative;
  top: 8px;
}

.message_type {
  width: 100%;
  height: 30px;
  position: relative;
}

.messagefield_label {
  float: left;
  padding-right: 2%;
  position: relative;
  top: 8px;
}

.messagefield_feild {
  float: left;
  width: 100%;
}

.btnsdiv {
  padding-left: 16%;
}

@media screen and (min-width: 900px) and (max-width: 1024px) {
  .pipeline_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
  }
  .target_label {
    float: left;
    padding-right: 9%;
    position: relative;
    top: 8px;
  }
  .processor_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
    font-size: 12px;
    font-weight: 700;
  }
  .processor_feild {
    float: left;
    width: 100%;
  }
  .message_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 8px;
  }
  .transaction_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
  }
  .transaction_feild {
    float: left;
    width: 100%;
  }
  .message_type {
    width: 53%;
    height: 35px;
    position: relative;
  }
  .message_type_margin {
    margin-left: 1% !important;
  }
  .pipeline_ellipsis {
    max-width: 85%;
  }
  .trans_ellipsis {
    max-width: 65%;
  }
  .message_btns span {
    padding: 0 !important;
  }
}
@media screen and (min-width: 500px) and (max-width: 786px) {
  .pipeline_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 0px;
  }
  .pipeline_feild {
    float: left;
    width: 100%;
  }
  .source_label {
    float: left;
    padding-right: 6%;
    position: relative;
    top: 0px;
  }
  .source_feild {
    float: left;
    width: 100%;
  }
  .target_label {
    float: left;
    padding-right: 9%;
    position: relative;
    top: 0px;
  }
  .target_feild {
    float: left;
    width: 100%;
  }
  .processor_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 0px;
    font-size: 12px;
    font-weight: 700;
  }
  .processor_feild {
    float: left;
    width: 100%;
  }
  .message_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 0px;
  }
  .message_feild {
    float: left;
    width: 100%;
  }
  .transaction_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 0px;
  }
  .transaction_feild {
    float: left;
    width: 100%;
  }
  .message_type {
    width: 86%;
    height: 35px;
    position: relative;
  }
  .reset_btn {
    padding-inline: 13% !important;
  }
  .gui_ellipsis {
    font-weight: 600;
    width: 65%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .message_type_margin {
    margin-left: 1% !important;
  }
  .pipeline_ellipsis {
    max-width: 81%;
  }
  .trans_ellipsis {
    max-width: 52%;
  }
  .message_btns span {
    padding: 0 !important;
  }
}
.rightalign {
  float: right;
  padding-right: 60px;
  padding-top: 10px;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline {
  height: 0px !important;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {
  top: 0;
  height: 0px !important;
  overflow: hidden;
}

.text-green {
  color: green;
}

.text-red {
  color: red;
}

::ng-deep.pipeSearch_messages .autocomplete-container .suggestions-container {
  position: absolute;
  background: #fff;
  height: auto;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  font-size: 14px;
}

::ng-deep.messageiot .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.messageiot {
  top: 4% !important;
}

::ng-deep.messageioteditor .editor-container {
  overflow: hidden !important;
  position: relative !important;
  display: table !important;
  width: 100% !important;
  height: 99% !important;
  min-width: 0 !important;
}

::ng-deep.messageiot .modal-dialog .modal-content .modal-footer {
  display: unset !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  justify-content: flex-end !important;
  padding: 0.3rem !important;
  border-top: 1px solid #dee2e6 !important;
  border-bottom-right-radius: calc(0.3rem - 1px) !important;
  border-bottom-left-radius: calc(0.3rem - 1px) !important;
}

::ng-deep.error_tab_list {
  height: 60vh !important;
  overflow: hidden auto !important;
}

::ng-deep.error_tab .mat-tab-header .mat-tab-label-container .mat-tab-list .mat-tab-labels .mat-tab-label:focus:not(.mat-tab-disabled) {
  opacity: unset !important;
}

::ng-deep.error_tab .mat-primary .mat-ink-bar,
.mat-tab-nav-bar.mat-primary .mat-ink-bar {
  background-color: #17a0b4 !important;
  margin-left: 11px;
}

.date_control_style {
  width: 100%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 2%;
}

.autocomplete-container .suggestions-container {
  position: absolute;
  background: #fff;
  height: auto;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  font-size: 14px;
}

::ng-deep.error_tab .mat-tab-label-container {
  height: 22px !important;
}

::ng-deep.error_tab .mat-tab-label {
  height: 24px !important;
}

::ng-deep.error_tab .mat-tab-label-active {
  color: black !important;
}

::ng-deep .mat-tab-body-content {
  overflow-x: hidden !important;
}

.fieldstyle {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  border-radius: 5px !important;
  border: transparent;
  width: 99% !important;
  min-height: 50px !important;
  max-height: 50px !important;
  overflow-x: hidden;
  overflow-y: auto;
}

.customchip {
  font-size: 12px;
  min-height: 21px !important;
  padding-inline: 8px !important;
  float: left !important;
}

.examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > div.mat-form-field-wrapper > div.mat-form-field-flex > div.mat-form-field-infix {
  padding-inline: 5px;
  padding-block: 1px;
  padding-top: 0px !important;
  min-height: 40px !important;
}

.examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > div.mat-form-field-wrapper > div.mat-form-field-flex > div.mat-form-field-infix > mat-chip-list.mat-chip-list {
  display: inline-block;
}

.examplechiplist .mat-form-field-appearance-fill.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  transform: translateY(-1.1em) scale(0.75);
  width: 133.33333%;
}

::ng-deep.examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > .mat-form-field-wrapper {
  flex-wrap: unset !important;
  overflow-x: scroll;
  padding-bottom: 0px !important;
  padding-top: 15px;
  display: flex;
}

::ng-deep.examplechiplist .mat-form-field-infix .mat-chip-list-wrapper {
  padding-top: 15px !important;
  float: left;
}

::ng-deep.examplechiplist2 .mat-form-field-infix .mat-chip-list-wrapper {
  padding-top: 0px !important;
  float: left;
}

::ng-deep.examplechiplist2 .mat-form-field-appearance-legacy .mat-form-field-wrapper {
  margin-top: -1% !important;
  margin-left: 2% !important;
  padding-bottom: 0px !important;
}

::ng-deep.examplechiplist .mat-form-field-appearance-legacy .mat-form-field-wrapper {
  margin-top: -3% !important;
  margin-left: 2% !important;
  padding-bottom: 0px !important;
}

.matchipinputfield.mat-chip-input {
  width: 150px;
  margin: 4px;
  flex: 1 0 150px;
}

.matchipinputfield2 input.mat-chip-input {
  width: 150px;
  margin: 4px;
  flex: 1 0 150px;
}

.msglistheight {
  max-height: 42vh;
  min-height: 42vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.msglistheightexp {
  max-height: 62vh;
  min-height: 62vh;
  overflow-x: hidden;
  overflow-y: auto;
}

::ng-deep.msgrep.mat-mdc-checkbox {
  height: 16px;
  width: 16px;
  position: relative;
  right: 3%;
  bottom: 9%;
}
::ng-deep.msgrep.mat-mdc-checkbox .mdc-checkbox {
  width: 16px;
  height: 16px;
}
::ng-deep.msgrep.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.msgrep.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.msgrep.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px;
  width: 16px;
}

::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px !important;
  width: 16px !important;
}

::ng-deep.badmsgcustomtab .mat-mdc-tab-body-wrapper {
  height: 60vh !important;
}

::ng-deep.badmsgcustomtabexp .mat-mdc-tab-body-wrapper {
  height: 36vh !important;
}`, "",{"version":3,"sources":["webpack://./src/app/errormessage/errormessagelist.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AACA;EACE,0BAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAEA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;AACF;;AA6CA;EACE,0BAAA;EACA,0BAAA;AA1CF;;AA8CA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;AA3CF;;AA8CA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AA3CF;;AA6CA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AA1CF;;AA6CA;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;AA1CF;;AA4CA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AAzCF;;AA2CA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAxCF;;AA0CA;EACE,yBAAA;AAvCF;;AAyCA;EACE,yBAAA;AAtCF;;AAyCA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AAtCF;;AAyCA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;AAtCF;;AAyCA;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;AAtCF;;AAwCA;EACE,8BAAA;AArCF;;AAuCA;EACE,8BAAA;AApCF;;AAsCA;EACE,mBAAA;AAnCF;;AAqCA;EACE,QAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;AAlCF;;AAoCA;EACE,kBAAA;EACA,4BAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;AAjCF;;AAmCA;EACE,8BAAA;AAhCF;;AAkCA;EACE,8BAAA;AA/BF;;AAkCA;EACE,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AA/BF;;AAiCA;EACE,iEAAA;AA9BF;;AAgCA;EACE,eAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;AA7BF;;AAgCA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AA7BF;;AA+BA;EACE,WAAA;EACA,WAAA;AA5BF;;AA+BA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AA5BF;;AA8BA;EACE,WAAA;EACA,WAAA;AA3BF;;AA8BA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AA3BF;;AA6BA;EACE,WAAA;EACA,WAAA;AA1BF;;AA6BA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AA1BF;;AA4BA;EACE,WAAA;EACA,WAAA;AAzBF;;AA2BA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAxBF;;AA0BA;EACE,WAAA;EACA,WAAA;AAvBF;;AA0BA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAvBF;;AAyBA;EACE,WAAA;EACA,WAAA;AAtBF;;AAyBA;EACE,kBAAA;EACA,oDAAA;EACE,WAAA;EACA,cAAA;EACA,0BCtRO;ADgQX;;AAwBA;EACE,WAAA;EACA,0BC1RS;ED2RT,aAAA;EACA,kBAAA;EACA,oDAAA;EACE,WAAA;AArBJ;;AAuBA;EACE,WAAA;EACA,0BClSS;EDmST,cAAA;EACA,kBAAA;EACA,oDAAA;EACA,WAAA;AApBF;;AAuBA;EACE,kBAAA;EACA,oDAAA;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,0BC/SO;AD2RX;;AAuBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AApBF;;AAuBA;EACE,WAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AApBF;;AAsBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAnBF;;AAqBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAlBF;;AAoBA;EACE,WAAA;EACA,WAAA;AAjBF;;AAoBA;EACE,iBAAA;AAjBF;;AAoBA;EACE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAjBF;EAoBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAlBF;EAoBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;IACA,eAAA;IACA,gBAAA;EAlBF;EAoBA;IACE,WAAA;IACA,WAAA;EAlBF;EAqBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAnBF;EAsBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EApBF;EAsBA;IACE,WAAA;IACA,WAAA;EApBF;EAsBA;IACE,UAAA;IACA,YAAA;IACA,kBAAA;EApBF;EAsBA;IACE,0BAAA;EApBF;EAsBA;IACE,cAAA;EApBF;EAsBA;IACE,cAAA;EApBF;EAuBE;IACE,qBAAA;EArBJ;AACF;AAyBA;EACE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAvBF;EA0BA;IACE,WAAA;IACA,WAAA;EAxBF;EA0BA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAxBF;EA0BA;IACE,WAAA;IACA,WAAA;EAxBF;EA0BA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAxBF;EA0BA;IACE,WAAA;IACA,WAAA;EAxBF;EA0BA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;IACA,eAAA;IACA,gBAAA;EAxBF;EA0BA;IACE,WAAA;IACA,WAAA;EAxBF;EA2BA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAzBF;EA2BA;IACE,WAAA;IACA,WAAA;EAzBF;EA2BA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAzBF;EA2BA;IACE,WAAA;IACA,WAAA;EAzBF;EA2BA;IACE,UAAA;IACA,YAAA;IACA,kBAAA;EAzBF;EA4BA;IACE,8BAAA;EA1BF;EA6BA;IACE,gBAAA;IACA,UAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;EA3BF;EA6BA;IACE,0BAAA;EA3BF;EA6BA;IACE,cAAA;EA3BF;EA6BA;IACE,cAAA;EA3BF;EA8BE;IACE,qBAAA;EA5BJ;AACF;AAgCA;EACE,YAAA;EACA,mBAAA;EACA,iBAAA;AA9BF;;AAiCA;EACE,sBAAA;AA9BF;;AAiCA;EACE,MAAA;EACA,sBAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,YAAA;AA9BF;;AAgCA;EACE,UAAA;AA7BF;;AAgCA;EACE,kBAAA;EAEA,gBAAA;EACA,YAAA;EACA,yCAAA;EACA,sBAAA;EACA,eAAA;AA9BF;;AAiCA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AA9BF;;AAgCA;EACE,kBAAA;AA7BF;;AAgCA;EACE,2BAAA;EACA,6BAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;AA7BF;;AAgCA;EACE,yBAAA;EACA,0BAAA;EACA,8BAAA;EACA,oCAAA;EACA,0BAAA;EACA,wCAAA;EACA,yDAAA;EACA,wDAAA;AA7BF;;AA+BA;EACE,uBAAA;EACA,gCAAA;AA5BF;;AA8BA;EAME,yBAAA;AAhCF;;AAkCA;;EAEE,oCAAA;EACA,iBAAA;AA/BF;;AAkCA;EACE,WAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;AA/BF;;AAkCA;EACE,kBAAA;EAEA,gBAAA;EACA,YAAA;EACA,yCAAA;EACA,sBAAA;EACA,eAAA;AAhCF;;AAkCA;EACE,uBAAA;AA/BF;;AAiCA;EACE,uBAAA;AA9BF;;AAiCA;EACE,uBAAA;AA9BF;;AAkCA;EACE,6BAAA;AA/BF;;AAiCA;EACE,yCAAA;EAAwC,6BAAA;EAAkC,mBAAA;EAC1E,qBAAA;EACA,2BAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;AA5BF;;AA8BA;EAEI,eAAA;EACA,2BAAA;EACA,8BAAA;EACA,sBAAA;AA5BJ;;AA8BE;EACE,mBAAA;EACE,kBAAA;EACA,2BAAA;EACA,2BAAA;AA3BN;;AA4BE;EAEG,qBAAA;AA1BL;;AA6BE;EACI,yCAAA;EACA,iBAAA;AA1BN;;AA4BE;EACA,2BAAA;EACA,kBAAA;EACA,8BAAA;EACA,iBAAA;EACA,aAAA;AAzBF;;AA2BA;EACE,4BAAA;EACA,WAAA;AAxBF;;AA0BA;EACE,2BAAA;EACA,WAAA;AAvBF;;AAyBA;EACE,0BAAA;EACA,0BAAA;EACC,8BAAA;AAtBH;;AAwBA;EACE,0BAAA;EACA,0BAAA;EACC,8BAAA;AArBH;;AAuBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;AApBF;;AAsBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;AAnBF;;AAqBA;EAEE,gBAAA;EAAiB,gBAAA;EAAgB,kBAAA;EAAmB,gBAAA;AAhBtD;;AAkBA;EAEE,gBAAA;EAAiB,gBAAA;EAAgB,kBAAA;EAAmB,gBAAA;AAbtD;;AAeA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAZF;AAaE;EACE,WAAA;EACA,YAAA;AAXJ;AAYI;EACE,gCCjsBM;EDksBN,oCClsBM;ADwrBZ;AAYI;EACE,YAAA;AAVN;AAaE;EACE,YAAA;EACA,WAAA;AAXJ;;AAeE;EACE,uBAAA;EACA,sBAAA;AAZJ;;AAeA;EACE,uBAAA;AAZF;;AAcA;EACE,uBAAA;AAXF","sourcesContent":["@import '../../variables.scss';\r\n.font_size {\r\n  font-size: 12px !important;\r\n}\r\n\r\n.ng-autocompleteroutr {\r\n  width: 370px;\r\n}\r\n.search_btnss {\r\n  background-color: #17a2b8;\r\n  color: white;\r\n  border: none;\r\n  outline: none;\r\n}\r\n\r\n.reset_btnss {\r\n  background-color: #17a2b8;\r\n  color: white;\r\n  border: none;\r\n}\r\n\r\n// ::ng-deep.autocomplete-container {\r\n//   box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n//   position: relative;\r\n//   overflow: visible;\r\n//   height: 40px;\r\n//   border-radius: 5px;\r\n// }\r\n\r\n// ::ng-deep.autocomplete-container .input-container input {\r\n//   border-radius: 5px !important;\r\n//   padding-right: 10% !important;\r\n//   padding-left: 2% !important;\r\n//   font-size: 11px;\r\n// }\r\n\r\n// ::ng-deep.autocomplete-container .suggestions-container ul li a {\r\n//   padding: 14px 15px;\r\n//   display: block;\r\n//   text-decoration: none;\r\n//   cursor: pointer;\r\n//   color: rgba(0,0,0,.87);\r\n//   font-size: 13px;\r\n// }\r\n// .autocomplete-container {\r\n//   border-radius: 5px !important;\r\n// }\r\n// ::ng-deep.autocomplete-container .input-container .x i {\r\n//   font-weight: 600 !important;\r\n//   color: rgba(0,0,0,.54);\r\n//   font-size: 16px;\r\n//   vertical-align: middle;\r\n//   padding: 0;\r\n//   position: relative;\r\n//   left: 7px;\r\n// }\r\n\r\n// ::ng-deep.pipeSearch_messages .autocomplete-container {\r\n//   height: 30px !important;\r\n//   .input-container input {\r\n//     height: 30px !important;\r\n//   }\r\n// }\r\n\r\n::ng-deep .mat-form-field-appearance-legacy .mat-form-field-wrapper {\r\n  margin-top: -3% !important;\r\n  margin-left: 2% !important;\r\n  // padding-bottom: 10% !important;\r\n}\r\n\r\n.link_Nonhighlight {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 90% !important;\r\n  display: inline-block;\r\n}\r\n\r\n.link_highlight {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 90% !important;\r\n  display: inline-block;\r\n  margin-right: 1%;\r\n}\r\n.link_highlight:hover {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 90% !important;\r\n  display: inline-block;\r\n  background-color: #3fa4fb;\r\n  padding-inline: 3%;\r\n  padding-block: 2px;\r\n  border-radius: 12px;\r\n  color: white !important;\r\n  cursor: pointer;\r\n}\r\n\r\n.iconCheck {\r\n  font-size: 12px;\r\n  position: relative;\r\n  top: -20%;\r\n  margin-left: -3px;\r\n}\r\n.doller {\r\n  position: absolute;\r\n  top: -11px;\r\n  left: 15%;\r\n}\r\n.textCenter {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n.text-success {\r\n  color: #5dd077 !important;\r\n}\r\n.text-danger {\r\n  color: #da606c !important;\r\n}\r\n\r\n.gui_ellipsis {\r\n  font-weight: 600;\r\n  max-width: 70%;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  display: inline-block;\r\n}\r\n\r\n.pipeline_ellipsis {\r\n  max-width: 89%;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  display: inline-block;\r\n  position: relative;\r\n  top: 8%;\r\n  left: 1%;\r\n  padding-right: 1%;\r\n}\r\n\r\n.trans_ellipsis {\r\n  max-width: 74%;\r\n  white-space: nowrap;\r\n  display: inline-block;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  position: relative;\r\n  top: 11%;\r\n  padding-right: 1%;\r\n}\r\n.active_card {\r\n  border-left: 4px solid #07a36e;\r\n}\r\n.progress_card {\r\n  border-left: 4px solid #ffc107;\r\n}\r\n.iconPointer:hover {\r\n  pointer-events: all;\r\n}\r\n.arrow_source {\r\n  left: 5%;\r\n  width: 97%;\r\n  height: 2px;\r\n  background-color: grey;\r\n  position: relative;\r\n  top: 36%;\r\n}\r\n.arr_chev {\r\n  position: relative;\r\n  text-align: right !important;\r\n  right: -98%;\r\n  color: grey;\r\n  top: -7px;\r\n}\r\n.failed_card {\r\n  border-left: 4px solid #da606c;\r\n}\r\n.healing_card {\r\n  border-left: 4px solid #f5a700;\r\n}\r\n\r\n.border-gradient {\r\n  border-left: 4px solid !important;\r\n  border-image-slice: 1;\r\n  border-block: 0;\r\n  border-right: 0;\r\n}\r\n.border-gradient-redgreen {\r\n  border-image-source: linear-gradient(to bottom, #db6c6c, #22ed86);\r\n}\r\n.copy_icon {\r\n  margin-left: 2%;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n  position: absolute;\r\n  top: 2px;\r\n}\r\n\r\n.pipeline_label {\r\n  float: left;\r\n  padding-right: 11%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.pipeline_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.source_label {\r\n  float: left;\r\n  padding-right: 9%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.source_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.target_label {\r\n  float: left;\r\n  padding-right: 13%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.target_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.processor_label {\r\n  float: left;\r\n  padding-right: 7%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.processor_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n.message_label {\r\n  float: left;\r\n  padding-right: 9%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.message_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.transaction_label {\r\n  float: left;\r\n  padding-right: 3%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.transaction_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.textFeid{\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    width: 100%;\r\n    height: 16.5vh;\r\n    font-size: $fontsize\r\n}\r\n.message_feild1{\r\n  float: left;\r\n  font-size: $fontsize;\r\n  height: 9.5vh;\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    width: 100%;\r\n}\r\n.message_feild3{\r\n  float: left;\r\n  font-size: $fontsize;\r\n  height: 15.8vh;\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n  width: 100%;\r\n}\r\n\r\n.message_feild2{\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    width: 100%;\r\n    float: left;\r\n    height: 5vh;\r\n    font-size: $fontsize;\r\n}\r\n\r\n.message_type_label {\r\n  float: left;\r\n  padding-right: 3%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n\r\n.message_type_feild {\r\n  width: 100%;\r\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  top: -6px;\r\n}\r\n.message_type_label {\r\n  float: left;\r\n  padding-right: 2%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.message_type {\r\n  width: 100%;\r\n  height: 30px;\r\n  position: relative;\r\n}\r\n\r\n.messagefield_label {\r\n  float: left;\r\n  padding-right: 2%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.messagefield_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.btnsdiv {\r\n  padding-left: 16%;\r\n}\r\n\r\n@media screen and (min-width: 900px) and (max-width: 1024px) {\r\n  .pipeline_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n\r\n  .target_label {\r\n    float: left;\r\n    padding-right: 9%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n  .processor_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 8px;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n  }\r\n  .processor_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n\r\n  .message_label {\r\n    float: left;\r\n    padding-right: 1%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n\r\n  .transaction_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n  .transaction_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .message_type {\r\n    width: 53%;\r\n    height: 35px;\r\n    position: relative;\r\n  }\r\n  .message_type_margin {\r\n    margin-left: 1% !important;\r\n  }\r\n  .pipeline_ellipsis {\r\n    max-width: 85%;\r\n  }\r\n  .trans_ellipsis {\r\n    max-width: 65%;\r\n  }\r\n  .message_btns {\r\n    span {\r\n      padding: 0 !important;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 500px) and (max-width: 786px) {\r\n  .pipeline_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 0px;\r\n  }\r\n\r\n  .pipeline_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .source_label {\r\n    float: left;\r\n    padding-right: 6%;\r\n    position: relative;\r\n    top: 0px;\r\n  }\r\n  .source_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .target_label {\r\n    float: left;\r\n    padding-right: 9%;\r\n    position: relative;\r\n    top: 0px;\r\n  }\r\n  .target_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .processor_label {\r\n    float: left;\r\n    padding-right: 1%;\r\n    position: relative;\r\n    top: 0px;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n  }\r\n  .processor_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n\r\n  .message_label {\r\n    float: left;\r\n    padding-right: 1%;\r\n    position: relative;\r\n    top: 0px;\r\n  }\r\n  .message_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .transaction_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 0px;\r\n  }\r\n  .transaction_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .message_type {\r\n    width: 86%;\r\n    height: 35px;\r\n    position: relative;\r\n  }\r\n\r\n  .reset_btn {\r\n    padding-inline: 13% !important;\r\n  }\r\n\r\n  .gui_ellipsis {\r\n    font-weight: 600;\r\n    width: 65%;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n  .message_type_margin {\r\n    margin-left: 1% !important;\r\n  }\r\n  .pipeline_ellipsis {\r\n    max-width: 81%;\r\n  }\r\n  .trans_ellipsis {\r\n    max-width: 52%;\r\n  }\r\n  .message_btns {\r\n    span {\r\n      padding: 0 !important;\r\n    }\r\n  }\r\n}\r\n\r\n.rightalign {\r\n  float: right;\r\n  padding-right: 60px;\r\n  padding-top: 10px;\r\n}\r\n\r\n::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline {\r\n  height: 0px !important;\r\n}\r\n\r\n::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {\r\n  top: 0;\r\n  height: 0px !important;\r\n  overflow: hidden;\r\n}\r\n\r\n.text-green {\r\n  color: green;\r\n}\r\n.text-red {\r\n  color: red;\r\n}\r\n\r\n::ng-deep.pipeSearch_messages .autocomplete-container .suggestions-container {\r\n  position: absolute;\r\n  // width: 170% !important;\r\n  background: #fff;\r\n  height: auto;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%);\r\n  box-sizing: border-box;\r\n  font-size: 14px;\r\n}\r\n\r\n::ng-deep.messageiot .modal-dialog {\r\n  max-width: 97% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.messageiot {\r\n  top: 4% !important;\r\n}\r\n\r\n::ng-deep.messageioteditor .editor-container {\r\n  overflow: hidden !important;\r\n  position: relative !important;\r\n  display: table !important;\r\n  width: 100% !important;\r\n  height: 99% !important;\r\n  min-width: 0 !important;\r\n}\r\n\r\n::ng-deep.messageiot .modal-dialog .modal-content .modal-footer {\r\n  display: unset !important;\r\n  flex-wrap: wrap !important;\r\n  align-items: center !important;\r\n  justify-content: flex-end !important;\r\n  padding: 0.3rem !important;\r\n  border-top: 1px solid #dee2e6 !important;\r\n  border-bottom-right-radius: calc(0.3rem - 1px) !important;\r\n  border-bottom-left-radius: calc(0.3rem - 1px) !important;\r\n}\r\n::ng-deep.error_tab_list  {\r\n  height: 60vh !important;\r\n  overflow: hidden auto !important;\r\n}\r\n::ng-deep.error_tab\r\n  .mat-tab-header\r\n  .mat-tab-label-container\r\n  .mat-tab-list\r\n  .mat-tab-labels\r\n  .mat-tab-label:focus:not(.mat-tab-disabled) {\r\n  opacity: unset !important;\r\n}\r\n::ng-deep.error_tab .mat-primary .mat-ink-bar,\r\n.mat-tab-nav-bar.mat-primary .mat-ink-bar {\r\n  background-color: #17a0b4 !important;\r\n  margin-left: 11px;\r\n}\r\n\r\n.date_control_style {\r\n  width: 100%;\r\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 2%;\r\n  // padding-block: 3%;\r\n}\r\n.autocomplete-container .suggestions-container {\r\n  position: absolute;\r\n\r\n  background: #fff;\r\n  height: auto;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%);\r\n  box-sizing: border-box;\r\n  font-size: 14px;\r\n}\r\n::ng-deep.error_tab .mat-tab-label-container {\r\n  height: 22px!important;;\r\n}\r\n::ng-deep.error_tab .mat-tab-label {\r\n  height: 24px !important;\r\n}\r\n\r\n::ng-deep.error_tab .mat-tab-label-active{\r\n  color:black !important;\r\n}\r\n\r\n\r\n::ng-deep .mat-tab-body-content {\r\n  overflow-x: hidden !important;\r\n}\r\n.fieldstyle{\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%); border-radius: 5px !important;    border: transparent;\r\n  width:99% !important;\r\n  min-height: 50px !important;\r\n  max-height: 50px !important;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n.customchip\r\n  {\r\n    font-size: 12px;\r\n    min-height: 21px !important;\r\n    padding-inline: 8px !important;\r\n    float: left !important;\r\n  }\r\n  .examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > div.mat-form-field-wrapper > div.mat-form-field-flex > div.mat-form-field-infix  {\r\n    padding-inline: 5px ;\r\n      padding-block: 1px ;\r\n      padding-top: 0px !important;\r\n      min-height: 40px !important ; }\r\n  .examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > div.mat-form-field-wrapper > div.mat-form-field-flex > div.mat-form-field-infix > mat-chip-list.mat-chip-list\r\n  {\r\n     display: inline-block;\r\n    }\r\n\r\n  .examplechiplist .mat-form-field-appearance-fill.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {\r\n      transform: translateY(-1.1em) scale(.75);\r\n      width: 133.33333%;\r\n  }\r\n  ::ng-deep.examplechiplist mat-form-field.mat-form-field.mat-form-field-appearance-fill > .mat-form-field-wrapper {\r\n  flex-wrap: unset !important;\r\n  overflow-x: scroll;\r\n  padding-bottom: 0px !important;\r\n  padding-top: 15px;\r\n  display: flex;\r\n}\r\n::ng-deep.examplechiplist .mat-form-field-infix .mat-chip-list-wrapper{\r\n  padding-top: 15px !important;\r\n  float: left;\r\n}\r\n::ng-deep.examplechiplist2 .mat-form-field-infix .mat-chip-list-wrapper{\r\n  padding-top: 0px !important;\r\n  float: left;\r\n}\r\n::ng-deep.examplechiplist2 .mat-form-field-appearance-legacy .mat-form-field-wrapper {\r\n  margin-top: -1% !important;\r\n  margin-left: 2% !important;\r\n   padding-bottom: 0px !important;\r\n}\r\n::ng-deep.examplechiplist .mat-form-field-appearance-legacy .mat-form-field-wrapper {\r\n  margin-top: -3% !important;\r\n  margin-left: 2% !important;\r\n   padding-bottom: 0px !important;\r\n}\r\n.matchipinputfield.mat-chip-input {\r\n  width: 150px;\r\n  margin: 4px;\r\n  flex: 1 0 150px;\r\n}\r\n.matchipinputfield2 input.mat-chip-input {\r\n  width: 150px;\r\n  margin: 4px;\r\n  flex: 1 0 150px;\r\n}\r\n.msglistheight\r\n{\r\n  max-height: 42vh;min-height:42vh;overflow-x: hidden;overflow-y: auto;\r\n}\r\n.msglistheightexp\r\n{\r\n  max-height: 62vh;min-height:62vh;overflow-x: hidden;overflow-y: auto;\r\n}\r\n::ng-deep.msgrep.mat-mdc-checkbox {\r\n  height: 16px;\r\n  width: 16px;\r\n  position: relative;\r\n  right: 3%;\r\n  bottom: 9%;\r\n  .mdc-checkbox {\r\n    width: 16px;\r\n    height: 16px;\r\n    .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n      border-color: $btn-color;\r\n      background-color: $btn-color;\r\n    }\r\n    .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n      color: white;\r\n  }\r\n  }\r\n  .mdc-checkbox__background{\r\n    height: 16px;\r\n    width: 16px;\r\n  }\r\n}\r\n::ng-deep.msgreplist.mat-mdc-checkbox {\r\n  .mdc-checkbox__background{\r\n    height: 16px !important;\r\n    width: 16px !important;\r\n  }\r\n}\r\n::ng-deep.badmsgcustomtab .mat-mdc-tab-body-wrapper{\r\n  height: 60vh !important;\r\n}\r\n::ng-deep.badmsgcustomtabexp .mat-mdc-tab-body-wrapper{\r\n  height: 36vh !important;\r\n}","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
